export default __webpack_public_path__ + "static/media/city.150f9add.png";